const FACULTIES: Record<string, string> = {
  "Финансово-экономический факультет": "ФЭФ",
  "Факультет информационных технологий": "ФИТ",
  "Факультет компьютерных наук и электроники": "ФКНЭ",
  "Гуманитарный факультет": "ГФ",
  "Инженерно-строительный факультет": "ИСФ",
  "Механико-технологический факультет": "МТФ",
  "Юридический факультет": "ЮФ",
};
export const facultyShort = (s = "") => FACULTIES[s] || s;
/** "Дневная форма" → "дневная". */
export const formShort = (s = "") => s.replace(/\s*форма$/i, "").toLowerCase();
